import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  Button,
  Card,
  CardHeader,
  CardActions,
  CardContent,
  IconButton,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Add, Edit, DeleteForever } from '@material-ui/icons';
import { cloneDeep, find, findIndex, forEach, sortBy, reverse } from 'lodash';
import { CSVLink } from 'react-csv';
// import CSVReader from 'react-csv-reader';
import CsvParse from '@vtex/react-csv-parse';
import { ExpandMore } from '@material-ui/icons';
import AreaParameterTable from '../areaParameters/AreaParameterTable';
import ParameterSelector from './ParameterSelector';
import ScoreTable from '../ScoreTable';
import { csvData } from '../Constants';
import { getArea, deleteArea } from './therapeuticAreaServices';
import { dialogModes } from '../Constants';
import TherapeuticAreaDialog from './TherapeuticAreaDialog';
import * as loaderActions from '../loader/loaderActions';

const useStyles = makeStyles({
  root: {
    justifyContent: 'flex-end',
  },
});

function TherapeuticArea({
  showLoader,
  hideLoader,
  therapeuticArea,
  getTherapeuticArea,
  updateThrapeuticAreaParameterList,
  match,
  history,
  deleteTherapeuticArea,
}) {
  const classes = useStyles();
  const [isDialogOpen, toggleDialog] = useState(false);
  const [fileName, changeFileName] = useState('');
  const [isTherapeuticAreaDialogOpen, toggleTherapeuticAreaDialog] = useState(
    false
  );
  const [dialogMode, changeDialogMode] = useState(dialogModes.add);
  const [isScoreTableOpen, toggleScoreTable] = useState(false);
  const [isSelectorOpen, toggleSelector] = useState(false);
  const [templateData, setTemplateData] = useState(cloneDeep(csvData));
  const [uploadedData, setUploadedData] = useState(null);
  const [thrapeuticAreaToEdit, setThrapeuticAreaToEdit] = useState(null);
  const [csvHeaders, setCSVHeaders] = useState([]);
  // const papaparseOptions = {
  //   header: true,
  //   skipEmptyLines: true,
  // };

  useEffect(() => {
    const areaId = match.params.id;
    getTherapeuticArea(areaId);
  }, []);

  useEffect(() => {
    const headers = ['HCP Number', 'HCP Name'];
    forEach(therapeuticArea.areaParameters, parameter => {
      headers.push(parameter.parameter.name);
    });
    setCSVHeaders(headers);
  }, [therapeuticArea]);

  const editThrapeuticArea = () => {
    changeDialogMode(dialogModes.update);
    setThrapeuticAreaToEdit({
      id: therapeuticArea.id,
      name: therapeuticArea.name,
      category: therapeuticArea.category.id,
    });
    toggleTherapeuticAreaDialog(true);
  };

  const removeThrapeuticArea = () => {
    deleteTherapeuticArea(
      {
        id: therapeuticArea.id,
        name: therapeuticArea.name,
        category: therapeuticArea.category.id,
      },
      () => {
        history.push('/therapeuticArea');
      }
    );
  };

  const updateParameterList = parameterList => {
    if (!parameterList) return;
    const therapeuticAreaCopy = cloneDeep(therapeuticArea);
    therapeuticAreaCopy.parameters = parameterList;
    updateThrapeuticAreaParameterList(therapeuticAreaCopy);
    isSelectorOpen && toggleSelector(false);
  };

  const onFileLoaded = (data, fileInfo) => {
    showLoader();
    setUploadedData(data);
    // changeFileName(fileInfo.name);
    toggleScoreTable(true);
    hideLoader();
    document.getElementById('CSVReader').value = '';
  };

  const onTemplateDownload = () => {
    setTemplateData(cloneDeep(csvData));
    const templateDataCopy = cloneDeep(csvData);
    forEach(therapeuticArea.areaParameters, parameter => {
      templateDataCopy.headers.push({ label: parameter.parameter.name });
    });
    setTemplateData(templateDataCopy);
    // var t = 6; toggleScoreTable(true);
  };

  const handleError = error => {
    let t = error;
  };

  return (
    <React.Fragment>
      <TherapeuticAreaDialog
        isDialogOpen={isTherapeuticAreaDialogOpen}
        toggleDialog={toggleTherapeuticAreaDialog}
        dialogMode={dialogMode}
        thrapeuticAreaToEdit={thrapeuticAreaToEdit}
        changeDialogMode={changeDialogMode}
        setThrapeuticAreaToEdit={setThrapeuticAreaToEdit}
        categoryId={therapeuticArea.category}
      />
      {isScoreTableOpen ? (
        <ScoreTable
          areaParameters={therapeuticArea.areaParameters}
          uploadedData={uploadedData}
          isScoreTableOpen={isScoreTableOpen}
          toggleScoreTable={toggleScoreTable}
          areaName={therapeuticArea.name}
          // fileName={fileName}
          therapeuticArea={therapeuticArea}
        />
      ) : null}
      {isSelectorOpen ? (
        <ParameterSelector
          isSelectorOpen={isSelectorOpen}
          toggleSelector={toggleSelector}
          selectedParameters={therapeuticArea.areaParameters}
          updateSelection={updateParameterList}
          areaId={therapeuticArea.id}
        />
      ) : null}
      <Card
        style={{
          width: '100%',
          marginTop: 16,
        }}
      >
        <CardHeader
          title={therapeuticArea.name}
          subheader={therapeuticArea.category.name}
          action={
            <React.Fragment>
              <IconButton color="secondary" onClick={removeThrapeuticArea}>
                <DeleteForever />
              </IconButton>
              <IconButton color="primary" onClick={editThrapeuticArea}>
                <Edit />
              </IconButton>
              <IconButton color="primary" onClick={() => toggleSelector(true)}>
                <Add />
              </IconButton>
            </React.Fragment>
          }
        />
        <CardActions className={classes.root}>
          <Button>
            <CSVLink
              headers={templateData.headers}
              onClick={onTemplateDownload}
              data={templateData.data}
              filename={`${therapeuticArea.name}.csv`}
            >
              Download template
            </CSVLink>
          </Button>
          {/* <CSVReader
            parserOptions={papaparseOptions}
            onFileLoaded={onFileLoaded}
            inputId="CSVReader"
          /> */}
          <CsvParse
            keys={csvHeaders}
            onDataUploaded={onFileLoaded}
            onError={handleError}
            render={onChange => (
              <input id="CSVReader" type="file" onChange={onChange} />
            )}
          />
        </CardActions>
        <CardContent>
          <AreaParameterTable areaParameters={therapeuticArea.areaParameters} />
        </CardContent>
      </Card>
    </React.Fragment>
  );
}

const mapStateToProps = state => ({ therapeuticArea: state.therapeuticArea });

const mapDispatchToProps = dispatch => ({
  getTherapeuticArea: areaId => dispatch(getArea(areaId)),
  deleteTherapeuticArea: (area, cb) => dispatch(deleteArea(area, cb)),
  showLoader: () => dispatch(loaderActions.showLoader()),
  hideLoader: () => dispatch(loaderActions.hideLoader()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TherapeuticArea)
);



// WEBPACK FOOTER //
// ./src/therapeuticArea/TherapeuticArea.js